(function (module) {
  'use strict';
  module.controller('HistoryController', ['$scope', 'alertService',
    function ($scope, alert) {},
  ]);
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/controllers/historyController.js